import React from 'react';
import { useAuthorization } from '@/auth/hooks/useAuthorization';
import { useSubtramiteForm } from '../../../hooks/useSubtramiteForm';
import { saveIrrigacion } from '../../../services/tramiteService';
import SubtramiteForm from '../../SubtramiteForm';
import { validaTiempo } from '../../../utils/validaciones';
import { withRequiredTramite } from './withRequiredTramite';

const Irrigacion: React.FC = () => {

  const {
    data,
    loading,
    init,
    isUpdate,
    setIsUpdate,
    handleChange,
    handleSubmit,
    handleFinalizarSubtramite,
    handleReabrirSubtramite
  } = useSubtramiteForm({
    subtramiteKey: 'irrigacion',
    defaultData: {
      habilitado: true,
      fecini: new Date(),
      cuenta: null,
      boleto: null,
      recibo: null,
      libredeuda: null,
      boleto_path: null,
      recibo_path: null,
      libredeuda_path: null,
    },
    saveFunction: saveIrrigacion,
    successMessage: 'Irrigacion Guardado con éxito',
    errorTitle: 'Error al grabar Irrigacion',
  });

  const {
    canManageTramites,
    canUploadTramitesFiles,
  } = useAuthorization();

  // Configuración de campos básicos
  const fields = [
    {
      type: 'toggle',
      name: 'habilitado',
      label: 'Habilitado:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
    {
      type: 'text',
      name: 'cuenta',
      label: 'Cuenta:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
    {
      type: 'date',
      name: 'fecini',
      label: 'Fecha de inicio:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
  ];

  // Configuración de campos de archivos
  const fileFields = [
    {
      type: 'file',
      name: 'boleto',
      label: 'Boleto:',
      pathField: 'boleto_path',
      visible: isUpdate,
      readOnly: !canUploadTramitesFiles,
      helpText: 'Acción a realizar por la tramitadora',
    },
    {
      type: 'file',
      name: 'recibo',
      label: 'Recibo:',
      pathField: 'recibo_path',
      visible: isUpdate,
      readOnly: !(canManageTramites || (canUploadTramitesFiles && validaTiempo(data.recibo_path, data.recibo_udt))),
      helpText: `Acción a realizar por el vendedor o la tramitadora.
              Puede realizar el pago del boleto en Bolsa de comercio, PagoFácil, RapiPago, Banco Nación o cualquier entidad autorizada.`,
    },
    {
      type: 'file',
      name: 'libredeuda',
      label: 'Libre deuda:',
      pathField: 'libredeuda_path',
      visible: isUpdate,
      readOnly: !canUploadTramitesFiles,
      helpText: 'Acción a realizar por la tramitadora',
    },
  ];

  const btnGuardarVisible = fields.some(field => field.visible) ||
    fileFields.some(field => field.visible && !field.readOnly);


  return (
    <SubtramiteForm
      title="Irrigación"
      data={data}
      loading={loading}
      init={init}
      isUpdate={isUpdate}
      setIsUpdate={setIsUpdate}

      handleChange={handleChange}
      handleSubmit={handleSubmit}
      handleFinalizarSubtramite={handleFinalizarSubtramite}
      handleReabrirSubtramite={handleReabrirSubtramite}
      btnGuardarVisible={btnGuardarVisible}
      fields={fields}
      fileFields={fileFields}
      subtramiteKey="irrigacion"
    />
  );
}

export default withRequiredTramite(Irrigacion);